import { render, staticRenderFns } from "./medicalIndex.vue?vue&type=template&id=b751ab74&scoped=true"
import script from "./medicalIndex.vue?vue&type=script&lang=js"
export * from "./medicalIndex.vue?vue&type=script&lang=js"
import style0 from "./medicalIndex.vue?vue&type=style&index=0&id=b751ab74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b751ab74",
  null
  
)

export default component.exports